import axios from 'axios';
import { useBearerTokenInterceptor } from './bearer-token.interceptor';

const base = 'https://api.upscaler.modelflow.studio';

export const useApi = () => {
  const upscalerInstance = axios.create({
    baseURL: base,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  const authenticatorInstance = axios.create({
    baseURL: base,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  const heartbeatInstance = axios.create({
    baseURL: base,
    headers: {
      'Content-Type': 'application/json',
    },
    validateStatus: () => true, // Don't throw on any status
    timeout: 3000, // 3 second timeout per request
  });

  upscalerInstance.interceptors.request.use(useBearerTokenInterceptor());
  heartbeatInstance.interceptors.request.use(useBearerTokenInterceptor());

  return {
    upscalerApi: upscalerInstance,
    authenticationApi: authenticatorInstance,
    heartbeatApi: heartbeatInstance,
  };
};
